import React, { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../../Layout";
import DrugServices from "../../Services/DrugServices";
import LocationService from "../../Services/LocationService";
import { Flex, message, Modal, Spin, Tooltip } from "antd";
import { convertUTCDate } from "../../utils/convertionFunc";
import MedicineCard from "./medicineCard";
import nodatafound from "../../assets/images/Svg/nodatafound.svg";
import { useSelector } from "react-redux";
import PatientService from "../../Services/PatientService";
import PrescriptionUpload from "./PrescriptionUpload";
import PaginationMed from "./PaginationMed";
const itemsPerPage = 12;

function BookMedicines() {
  const [medicines, setMedicines] = useState([]);
  const [loader, setLoader] = useState(false);
  const [addressLoader, setAddressLoader] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currPageMed, setCurrPageMed] = useState([]);
  const [isSearched, setIsSearched] = useState(false);
  const [addressModButton, setAddressModButton] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const totalPages = Math.ceil(medicines?.length / itemsPerPage);
  const paginatedMedicines = medicines
    ? medicines.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage,
    )
    : [];
  const [showModal, setShowModal] = useState(false);
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [availPinCode, setAvailPincode] = useState("");
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    mobile: "",
    pinCode: "",
    state: "",
  });
  const [deliverable, setDeliverable] = useState("");
  const { countries, states } = useSelector((state) => state.common);
  const { patientData } = useSelector((state) => state.auth);

  useEffect(() => {
    // fetchMedicines(""); // Removed initial fetch
  }, []);

  useEffect(() => {
    // fetchMedicines(searchVal); // Removed fetch on patientData change

    if (patientData?.pinCode) {
      setAvailPincode(patientData.pinCode);
      checkServiceAvailability(patientData.pinCode);
      setDeliverable("");
    }
  }, [patientData]);

  useEffect(() => {
    if (patientData) {
      fetchPatientAddress();
    }
  }, [patientData]);

  useEffect(() => {
    if (medicines.length > 0) {
      const paginatedMedicines = medicines.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      );
      setCurrPageMed(paginatedMedicines);
    }
  }, [medicines, currentPage]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target) &&
      inputRef.current !== e.target
    ) {
      setShowDropdown(false);
    }
  };

  const fetchMedicines = async (searchVal, pageNo = 1) => {
    if (!searchVal) {
      setMedicines([]);
      setIsSearched(false);
      setLoader(false);
      return;
    }
    setLoader(true);
    setIsSearched(true);
    setCurrentPage(pageNo);

    try {
      const response = await DrugServices.fetchDrugList(searchVal, pageNo);
      if (response?.data?.data) {
        setMedicines(response?.data?.data);
        setLoader(false);
      } else {
        setMedicines([]);
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchVal(value);
    if (value && value.length >= 3) {
      fetchMedicines(value);
      setShowDropdown(true);
    } else if (!value) {
      setMedicines([]);
      setIsSearched(false);
      setShowDropdown(false);
    }
  };

  const handleSelectMed = (item) => {
    setMedicines([item]);
    setShowDropdown(false);
  };

  const fetchPatientAddress = async () => {
    let payload = {
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
    };

    try {
      setLoading(true);
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddress(result?.data?.[0] || null);
      } else {
        setAddressModButton(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const checkAvail = (e) => {
    const pincode = e.target.value;
    setAvailPincode(pincode);

    if (pincode.length === 6) {
      checkServiceAvailability(pincode);
    }
  };

  const checkServiceAvailability = async (pincode) => {
    if (!pincode || pincode.length !== 6) return;

    let payload = {
      pincode,
      status: 1,
    };

    try {
      let result = await LocationService.checkAvailability(payload);

      if (result.data.length > 0) {
        setDeliverable(pincode);
        setShowModal(false);
      } else {
        message.error(
          "Service is not available in this area, choose another area",
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAddressSave = async (e) => {
    e.preventDefault();
    const isFormEmpty = Object.values(formData).every(
      (value) => value.trim() === "",
    );

    if (isFormEmpty) {
      message.error("Please enter values in the form");
      return;
    }

    let payload = {
      account_Id: patientData.account_Id,
      clinic_Id: patientData.clinic_Id,
      createdBy: patientData.patientId,
      modifiedBy: patientData.patientId,
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ...formData,
    };
    setAddressLoader(true);
    try {
      await LocationService.savePatientAddress(payload);
      setAddressModButton(false);
      setIsAddressModalOpen(false);
      checkServiceAvailability(formData.pinCode);
      setAvailPincode(formData.pinCode);
      fetchPatientAddress();
    } catch (error) {
      console.error(error);
      setAddressLoader(false);
    } finally {
      setAddressLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNewAddress = () => {
    setIsAddressModalOpen(true);
    setFormData((prevState) => ({
      ...prevState,
      firstName: patientData?.firstName,
      address1: patientData?.address1,
      address2: patientData?.address2,
      city: patientData?.city,
      country: patientData?.country,
      mobile: patientData?.mobile,
      pinCode: patientData?.pinCode,
      state: patientData?.state,
    }));
  };

  const handleAdrrsFormClose = () => {
    setIsAddressModalOpen(false);
    setFormData({
      firstName: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      mobile: "",
      pinCode: "",
      state: "",
    });
  };



  return (
    <Layout>
      <div className="py-6 px-4 w-full max-w-[1400px] mx-auto">
        <h2 className="text-[#189FAA] font-sans font-bold text-2xl mb-6">
          Medicines
        </h2>
        <div className="flex gap-8 items-start sm:flex-col">
          <div className="flex-1 bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <div className="w-full">
              <div className="flex sm:flex-col justify-center gap-3 mt-3">
                <div className="flex items-center border rounded-md px-3 py-1">
                  <MdLocationOn className="text-[#189FAA] text-lg mr-2" />
                  <input
                    type="text"
                    placeholder="Enter Pincode"
                    onChange={checkAvail}
                    value={availPinCode}
                    className="text-sm font-sans font-medium outline-none placeholder:text-xs w-full"
                  />
                </div>
                <div class="relative w-[480px] sm:w-full rounded-md border p-1">
                  <input
                    type="text"
                    class="w-full pl-8 pr-24 py-1 font-sans font-medium text-sm placeholder:text-xs text-gray-700 bg-transparent rounded-md focus:outline-none"
                    placeholder="Search medicine"
                    onChange={handleSearch}
                  />
                  <button
                    onClick={() => fetchMedicines(searchVal)}
                    className="absolute right-1 top-1 bottom-1 px-6 bg-[#189FAA] text-white font-sans text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5044e4]"
                  >
                    Search
                  </button>
                  {showDropdown && (
                    <div
                      ref={dropdownRef}
                      className="absolute z-40 top-full left-0 w-full bg-white h-[300px] overflow-auto scrollWidth shadow-lg rounded-lg p-1 mt-1"
                    >
                      <ul>
                        {medicines?.map((med) => (
                          <li
                            onClick={() => handleSelectMed(med)}
                            key={med.code}
                            className="p-2 hover:bg-gray-200 cursor-pointer"
                          >
                            {med.medicineName}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {/* {patientData && (
                  <h3
                    className="font-sans underline cursor-pointer mx-2 font-semibold text-sm text-[#189FAA]"
                    onClick={handleNewAddress}
                  >
                    Add address
                  </h3>
                )} */}
              </div>
            </div>
            <div className="mt-8">
              <div className="w-full">
                {!isSearched ? (
                  <div className="flex flex-col items-center justify-center h-[300px] border-2 border-dashed border-gray-100 rounded-2xl bg-gray-50/30">
                    <p className="text-gray-400 font-medium font-sans">
                      Search for medicines to see results
                    </p>
                  </div>
                ) : loader && medicines?.length === 0 ? (
                  <div className="w-full h-[300px] flex items-center justify-center">
                    <Flex align="center" gap="middle">
                      <Spin size="large" tip="Loading" />
                    </Flex>
                  </div>
                ) : isSearched && !loader && medicines?.length === 0 ? (
                  <div className="flex flex-col items-center justify-center">
                    <img
                      src={nodatafound}
                      alt="nodatafound"
                      className="h-min w-min"
                    />
                    <p className="font-medium text-xl">
                      No results found for "{searchVal}"
                    </p>
                  </div>
                ) : (
                  <div className="grid grid-cols-4 sm:grid-cols-1  gap-4">
                    {currPageMed.map((medicine) => (
                      <MedicineCard
                        address={address}
                        medicine={medicine}
                        deliverable={deliverable}
                      />
                    ))}
                  </div>
                )}
              </div>
              {medicines.length > itemsPerPage && (
                <div className="mt-8">
                  <PaginationMed
                    currentPage={currentPage}
                    totalPages={totalPages}
                    goToPage={(e, page) => handlePageChange(page)}
                  />
                </div>
              )}
            </div>

            <Modal
              title={
                <span className="text-sm font-semibold font-sans text-[#189FAA]">
                  Add Address
                </span>
              }
              open={isAddressModalOpen}
              onCancel={handleAdrrsFormClose}
              footer={[]}
              destroyOnClose
            >
              <form className="space-y-4 mt-3">
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="Name"
                    name="firstName"
                    disabled={true}
                    value={formData.firstName || ""}
                    className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
                  />
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
                  />
                </div>
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="City"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
                  />
                  <input
                    type="text"
                    placeholder="Pin Code"
                    name="pinCode"
                    value={formData.pinCode}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
                  />
                </div>
                <div className="flex gap-2">
                  <select
                    value={formData.state}
                    onChange={handleChange}
                    name="state"
                    className="w-full py-2 px-3 border rounded text-xs text-gray-400 font-sans  outline-none"
                  >
                    <option value="" disabled>
                      Select State
                    </option>
                    {states.map((state) => (
                      <option key={state.stateId} value={state.stateId}>
                        {state.stateName}
                      </option>
                    ))}
                  </select>
                  <select
                    value={formData.country}
                    onChange={handleChange}
                    name="country"
                    className="w-full px-3 py-2 border rounded font-sans text-gray-400  text-xs outline-none"
                  >
                    <option value="" disabled>
                      Select Country
                    </option>
                    {countries.map((country) => (
                      <option
                        key={country.country_Id}
                        value={country.country_Id}
                      >
                        {country.country_Name}
                      </option>
                    ))}
                  </select>
                </div>
                <textarea
                  placeholder="Full Address"
                  rows="3"
                  value={formData.address1}
                  name="address1"
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
                />

                <div className="flex justify-end gap-4 mt-4">
                  <button
                    type="button"
                    disabled={addressLoader}
                    onClick={handleAdrrsFormClose}
                    className="px-4 py-1 border border-cyan-600 font-sans text-sm font-medium text-cyan-600 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Cancel
                  </button>
                  <button
                    disabled={addressLoader}
                    className="px-4 py-1 bg-[#189FAA] font-sans text-sm text-white font-semibold rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleAddressSave}
                  >
                    Save Address
                  </button>
                </div>
              </form>
            </Modal>
          </div>
          <div className="w-80 sm:w-full shrink-0">
            <PrescriptionUpload />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default BookMedicines;
